import { siteConfig } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20fantasy%20battlefield%20with%20thousands%20of%20warriors%20and%20flying%20banners%2C%20dramatic%20sunset%20sky%20with%20golden%20clouds%2C%20cinematic%20game%20art%20style%2C%20warm%20crimson%20and%20amber%20tones%2C%20atmospheric%20fog%2C%20heroic%20composition%2C%20rich%20detail%2C%20grand%20scale&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="征途国际"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 backdrop-blur-sm mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs md:text-sm text-accent-200 font-medium">
            最新版本 {siteConfig.version} · {siteConfig.updateDate} 更新
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 mb-4 leading-tight">
          {siteConfig.tagline}
        </h1>
        <p className="text-base md:text-lg text-foreground-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          征途国际App最新版官方下载安装，支持Android与iOS双平台，安全无病毒，一键安装即玩。
          经典征途国际手游焕新升级，海量玩法等你体验，立即下载征途国际最新版App！
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={siteConfig.androidDownloadUrl}
            className="group flex items-center gap-2.5 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 shadow-[0_8px_30px_rgba(180,40,20,0.35)] hover:shadow-[0_12px_40px_rgba(180,40,20,0.5)] whitespace-nowrap cursor-pointer"
          >
            <i className="ri-android-line text-xl group-hover:scale-110 transition-transform duration-300"></i>
            Android 下载
            <span className="text-xs opacity-80 ml-1">APK安装包</span>
          </a>
          <a
            href={siteConfig.iosDownloadUrl}
            className="group flex items-center gap-2.5 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 rounded-full text-base font-semibold hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-apple-line text-xl group-hover:scale-110 transition-transform duration-300"></i>
            iOS 下载
            <span className="text-xs opacity-80 ml-1">App Store</span>
          </a>
        </div>

        <div className="flex items-center justify-center gap-6 mt-8 text-xs md:text-sm text-foreground-300">
          <span className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-accent-400 text-sm"></i>
            官方正版
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-virus-line text-accent-400 text-sm"></i>
            安全无毒
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-refresh-line text-accent-400 text-sm"></i>
            双端互通
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-download-cloud-line text-accent-400 text-sm"></i>
            一键安装
          </span>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}